/*
 * Locks Rebuy's native discount disclosure for URL discounts while keeping its
 * applied tag, amount, and native removal control available.
 */
window.URLDiscountManager = (function () {
  let debug = false;
  let observer = null;
  let manageTimer = null;
  let visibleURLTagCode = null;

  function log(...args) {
    if (debug) console.log('[URLDiscountManager]', ...args);
  }

  function getURLDiscountCode() {
    const discountCookie = document.cookie
      .split(';')
      .find(cookie => cookie.trim().startsWith('discount_code='));
    if (!discountCookie) return null;

    const value = discountCookie.split('=').slice(1).join('=');
    if (!value || value === 'undefined') return null;

    try {
      return decodeURIComponent(value).trim().toUpperCase() || null;
    } catch (error) {
      return value.trim().toUpperCase() || null;
    }
  }

  function getDiscountInput() {
    return document.querySelector('[data-rebuy-component="discount-input"]');
  }

  function getURLDiscountTag(code) {
    if (!code) return null;
    return Array.from(document.querySelectorAll('.rebuy-cart__discount-tag')).find(tag =>
      tag.textContent.toUpperCase().includes(code)
    );
  }

  function clearURLDiscountCookie() {
    document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    log('Cleared URL discount cookie after its applied tag was removed');
  }

  function setArrowVisibility(arrow, hidden) {
    if (!arrow) return;

    if (hidden) {
      if (!Object.prototype.hasOwnProperty.call(arrow.dataset, 'bwbOriginalDisplay')) {
        arrow.dataset.bwbOriginalDisplay = arrow.style.getPropertyValue('display');
        arrow.dataset.bwbOriginalDisplayPriority = arrow.style.getPropertyPriority('display');
      }
      arrow.style.setProperty('display', 'none', 'important');
      return;
    }

    const display = arrow.dataset.bwbOriginalDisplay || '';
    const priority = arrow.dataset.bwbOriginalDisplayPriority || '';
    arrow.style.setProperty('display', display, priority);
    delete arrow.dataset.bwbOriginalDisplay;
    delete arrow.dataset.bwbOriginalDisplayPriority;
  }

  function lockDisclosure(discountInput) {
    const disclosure = discountInput.querySelector('.rebuy-cart__discount-disclosure');
    if (!disclosure) return;

    // A previous version hid the entire Rebuy component. Clear that inline
    // override so the tag, URL saving, and native removal control remain visible.
    discountInput.style.removeProperty('display');
    discountInput.classList.add('bwb-url-discount-locked');
    disclosure.removeAttribute('open');

    const label = disclosure.querySelector('.rebuy-cart__discount-summary-label');
    if (label) {
      if (!Object.prototype.hasOwnProperty.call(label.dataset, 'bwbOriginalLabel')) {
        label.dataset.bwbOriginalLabel = label.textContent;
      }
      label.textContent = 'CODICE APPLICATO!';
    }

    const summary = disclosure.querySelector('.rebuy-cart__discount-summary');
    if (summary) {
      summary.setAttribute('aria-disabled', 'true');
      summary.tabIndex = -1;
    }
    setArrowVisibility(disclosure.querySelector('.rebuy-cart__discount-summary-arrow'), true);
  }

  function unlockDisclosure(discountInput) {
    discountInput.classList.remove('bwb-url-discount-locked');

    const disclosure = discountInput.querySelector('.rebuy-cart__discount-disclosure');
    if (!disclosure) return;

    const label = disclosure.querySelector('.rebuy-cart__discount-summary-label');
    if (label && Object.prototype.hasOwnProperty.call(label.dataset, 'bwbOriginalLabel')) {
      label.textContent = label.dataset.bwbOriginalLabel;
      delete label.dataset.bwbOriginalLabel;
    }

    const summary = disclosure.querySelector('.rebuy-cart__discount-summary');
    if (summary) {
      summary.removeAttribute('aria-disabled');
      summary.removeAttribute('tabindex');
    }
    setArrowVisibility(disclosure.querySelector('.rebuy-cart__discount-summary-arrow'), false);
  }

  function manageDiscountInput() {
    const discountInput = getDiscountInput();
    if (!discountInput) return;

    const urlCode = getURLDiscountCode();
    const visibleTag = getURLDiscountTag(urlCode);

    if (urlCode) {
      if (visibleTag) visibleURLTagCode = urlCode;

      // Lock immediately for URL visitors. Rebuy can render the disclosure
      // before it has rendered the applied tag, which must not briefly expose
      // code entry or be treated as a user-initiated tag removal.
      if (!visibleURLTagCode || visibleTag) {
        lockDisclosure(discountInput);
        return;
      }

      // The URL tag was previously visible and has now disappeared, so this
      // is the native removal path rather than Rebuy's initial render delay.
      clearURLDiscountCookie();
      visibleURLTagCode = null;
      unlockDisclosure(discountInput);
      return;
    }

    if (visibleURLTagCode && !getURLDiscountTag(visibleURLTagCode)) {
      clearURLDiscountCookie();
      visibleURLTagCode = null;
    }
    unlockDisclosure(discountInput);
  }

  function scheduleManage() {
    if (manageTimer) return;
    manageTimer = window.setTimeout(() => {
      manageTimer = null;
      manageDiscountInput();
    }, 0);
  }

  return {
    init: function () {
      if (!window.RebuyEventManager) {
        console.error('[URLDiscountManager] RebuyEventManager not available');
        return this;
      }

      window.RebuyEventManager.on('cart:show', scheduleManage)
        .on('cart:change', scheduleManage)
        .on('cart:ready', scheduleManage)
        .on('discount:applied', scheduleManage)
        .on('discount:removed', scheduleManage);

      observer = new MutationObserver(scheduleManage);
      observer.observe(document.body, { childList: true, subtree: true });

      window.addEventListener('pageshow', scheduleManage);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') scheduleManage();
      });

      scheduleManage();
      return this;
    },

    refresh: function () {
      scheduleManage();
      return this;
    },

    debug: function (enabled) {
      debug = enabled;
      return this;
    },
  };
})();
